/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { SdsDivProps } from '../Component.props';

/**
 * The props for `<ErrorMessage />`.
 */
export interface ErrorMessageProps extends SdsDivProps {
  /**
   * Display a container around the error message.
   */
  contained?: boolean;

  /**
   * Error message to display.
   */
  message: string;
}

/**
 * The default prop values for `<ErrorMessage />`.
 */
export const errorMessageDefaults = {
  contained: false,
};
